window.addEventListener("load", () => {
  document.querySelectorAll(".collection-list__item").forEach(function (e) {
    document.querySelectorAll(".collection-true").forEach(function (e) {
      e.classList.add("active-ed"), (e.parentElement.style.display = "none");
    });
  }),
    $(".category-slide-all").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: !0,
      dots: !1,
      speed: 300,
      infinite: !0,
      autoplaySpeed: 5e3,
      autoplay: !0,
      responsive: [
        { breakpoint: 1600, settings: { slidesToShow: 5 } },
        { breakpoint: 1400, settings: { slidesToShow: 4 } },
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 767, settings: { 
          slidesToShow: 1,
          autoplay:false,
          dots:true,
          arrows:false,
          centerMode:true
        } 
        },
      ],
    }),
    $(".all-reviews-slide").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !1,
      dots: !0,
      speed: 300,
      infinite: !0,
      autoplaySpeed: 5e3,
      autoplay: !0,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 2 } },
        { breakpoint: 767, settings: { slidesToShow: 1 } },
      ],
    }),
    $(".slider_wrapper").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !0,
      dots: !1,
      speed: 300,
      infinite: !0,
      autoplaySpeed: 5e3,
      autoplay: !0,
      responsive: [
        { breakpoint: 1600, settings: { slidesToShow: 3 } },
        { breakpoint: 1400, settings: { slidesToShow: 3 } },
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        {
          breakpoint: 767,
          settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
      ],
    });
  var e = setInterval(function s() {
    $(".slider_wrapper").hasClass("slick-initialized") &&
      ($(".slider_wrapper").removeClass("not-init"), clearInterval(e));
  }, 100);
});
